import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const GuideIntegrationPoints = (props: Props) => {
    return (
        <S_GuideIntegrationPoints className={props.className}>
            Guide Integration Points
        </S_GuideIntegrationPoints>
    );
};

const S_GuideIntegrationPoints = styled.div``;
